import { Button as MuiButton } from '@mui/material';
import * as React from 'react';
import { TButton } from './Button.types';
import './Button.styles.scss';

export const Button: TButton = (props) => {
  return (
    <MuiButton className="button" {...props}>
      <span>{props.children}</span>
    </MuiButton>
  );
};
